"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Zorgaanbod() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section id="zorgaanbod" className="relative flex min-h-[70vh] items-center justify-center overflow-hidden bg-background py-24">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576260/img/bright_airy_home_interior_care.png)] bg-cover bg-center bg-fixed bg-no-repeat" />
        {}
        <div className="absolute inset-0 bg-primary/5 mix-blend-multiply" />
      </div>

      {}
      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div ref={ref} className={`mx-auto max-w-3xl rounded-[2rem] border border-border/40 bg-background/85 p-8 text-center shadow-2xl backdrop-blur-md transition-all duration-1000 ease-out md:p-16 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <span className="mb-4 block text-sm font-semibold tracking-wider text-primary uppercase">
            CuraNova Zorg
          </span>
          <h1 className="mb-6 font-serif text-4xl leading-tight font-bold text-foreground md:text-5xl lg:text-6xl">
            Passende zorg in de thuissituatie
          </h1>
          <p className="mx-auto max-w-2xl text-lg leading-relaxed text-muted-foreground md:text-xl">
            Een gedetailleerd overzicht van onze diensten, van complexe
            psychogeriatrische ondersteuning tot praktische huishoudelijke hulp.
            Wij bieden persoonsgerichte zorg, afgestemd op uw unieke situatie en
            behoeften.
          </p>
        </div>
      </div>
    </section>;
}